import React from 'react';

import VideoPlayer from '../../../../components/VideoPlayer';
import AdminProviderHeading from '../../../../components/AdminProviderHeading';
import { CenteredWithGutters } from '../../../../components/ProviderDetailsForm/styles';
import { StyledExternalLink } from '../../../../components/Link';
import { Provider, ProviderId } from '../../../../state/types';
import { PROVIDER_TABS_WELCOME } from '../../constants';
import { StyledAlphaHeading, StyledGammeHeading, Card, Columns, CardHeading, BulletList, WideCard, CardLead } from './styles'
import Downloadable from './Downloadable';
import { downloads } from './downloads';

interface WelcomeProviderProps {
    authorizedProviderIds: ProviderId[];
    provider?: Provider;
};


const WelcomeProvider: React.FC<WelcomeProviderProps> = ({ authorizedProviderIds: providerIds, provider }) => {
    const numDownloads = downloads.length
    const maxDownloadsPerLine = 3
    const minWidthPerItem = "30%" // allow for margin
    const offsetAmount = numDownloads > maxDownloadsPerLine ? numDownloads % maxDownloadsPerLine : 0
    const offsetWidthPerItem = `${(9 / offsetAmount) * 10}%`
    const downloadItems = downloads.map(({ title, url, preview }, index) => (
        <div key={`download_${url}`} style={{ flex: 1, alignSelf: 'stretch', flexBasis: index < offsetAmount ? offsetWidthPerItem : minWidthPerItem }}>
            <Downloadable key={title} title={title} url={url} preview={preview} />
        </div>
    ))
    return (
        <div>
            {providerIds && (
                <AdminProviderHeading
                  currentPage={PROVIDER_TABS_WELCOME}
                  providerId={provider && provider.id}
                  providerName={provider && provider.name}
                  providerSlug={provider && provider.url_slug}
                  providerRating={provider && provider.overall_review}
                />
            )}
            <CenteredWithGutters>
                <section>
                    <StyledAlphaHeading>Welcome</StyledAlphaHeading>
                    <p>
                        Welcome to your Provider Admin portal. Here you will find your Profile
                        information page and access to your Reviews.
                    </p>
                    <p>
                        There are also helpful videos and a Provider toolkit.
                    </p>
                </section>
                <StyledGammeHeading>Your subscription</StyledGammeHeading>
                <p>
                    Your subscription provides you with a listing on the Karista website and the
                    ability to collect requests and referrals, as well as reviews. If you want to
                    unsubscribe, we require 30 days’ notice in writing to <StyledExternalLink href="mailto:accounts@karista.com.au">accounts@karista.com.au</StyledExternalLink>
                </p>
                <StyledGammeHeading>Client Services Team</StyledGammeHeading>
                <p>
                    Our Client Services Team are one of the first points of contact for our clients
                    looking for services and for you, the provider. If you have any questions you can
                    email <StyledExternalLink href="mailto:clientservicesteam@karista.com.au">clientservicesteam@karista.com.au</StyledExternalLink>
                </p>
                <Columns>
                    <Card>
                        <CardHeading>Welcome video</CardHeading>
                        <CardLead>
                            Watch our 5 minute welcome video which outlines some important features of your subscription and covers information on:
                        </CardLead>
                        <BulletList>
                            <li>Your profile</li>
                            <li>Reviews and ideas for gaining them</li>
                            <li>How requests and referrals work</li>
                            <li>Provider e-toolkit</li>
                        </BulletList>
                        <VideoPlayer videoLink="https://player.vimeo.com/video/723627878?h=cd273cdd43&title=0&byline=0&portrait=0" />
                    </Card>
                    <Card>
                        <CardHeading>Review demonstration video</CardHeading>
                        <CardLead>
                            It’s easy for clients to leave you a review. Watch this demonstration video to see how.
                        </CardLead>
                        <VideoPlayer videoLink="https://player.vimeo.com/video/723627565?h=b7c1cee876&title=0&byline=0&portrait=0" />
                    </Card>
                    <WideCard>
                        <CardHeading>Provider eToolkit</CardHeading>
                        <CardLead>Download some useful items to help you make the most of your Karista subscription.</CardLead>
                        <Columns>
                            {downloadItems}
                        </Columns>
                    </WideCard>
                </Columns>
            </CenteredWithGutters>
        </div>
    )
}

export default WelcomeProvider